import { HubHandlerSourceAngularJS } from "@models/system";
import { cipo } from "cipo";

var tenantController = function ($scope, $timeout, signalRService) {
    $scope.openMenu = function ($mdMenu, ev) {
        $mdMenu.open(ev);
        $timeout(function () {
            $scope.focusSearch = true;
            $timeout(function () {
                $scope.focusSearch = false;
            }, 300);
        }, 300);
    };

    // sample how to register handlers for SignalR events on AngularJS
    signalRService.registerHandler(HubHandlerSourceAngularJS, 'NewEmailSent', function (contractId) {
        console.log(HubHandlerSourceAngularJS, 'NewEmailSent to contractId', contractId);
    });
};

cipo.controller("tenantController", tenantController);
